import styled from 'styled-components';
import { BaseContainer } from '../BaseContainer';
import { sizes } from '../../theme/modules/sizes';
export const Grid = styled(BaseContainer).withConfig({ displayName: "vui--Grid", componentId: "vui--12w0ynf" }) `display:grid;grid-template-columns:repeat(${({ columns }) => columns}, 1fr);grid-gap:${({ spacing = 'base' }) => (spacing ? sizes[spacing] : 0)};`;
//# sourceMappingURL=index.js.map